import editSchema from "../../getters/editSchema";

const c4Diagram = editSchema;
export default c4Diagram;
